/**
 * Info panel — sky stripe + Info icon. Schema mirrors the rest of the
 * named-panel set; visual identity comes from `NAMED_PANELS[0]`.
 */

import { buildNamedPanelView } from './NamedPanelView'
import { buildPanelExtension } from './panel-extension-factory'
import { NAMED_PANELS } from './panel-kinds'

const spec = NAMED_PANELS.find((p) => p.kind === 'info')
if (!spec) throw new Error('NAMED_PANELS missing info kind — registry shape changed')

export const InfoPanel = buildPanelExtension({
  name: spec.nodeName,
  dataBlockType: spec.dataBlockType,
  view: buildNamedPanelView(spec),
})
